import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

import { API_URL, scroll, getValFromLS, setValToLS } from "../helpers";

import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Input from "../components/Input";
import Checkbox from "../components/Checkbox";
import Checkboxes from "../components/Checkboxes/index";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

const CharityRegHome = () => {
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({
		id: "0",
		cats: [],
	});
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const history = useHistory();
	const formElement = useRef(null);

	useEffect(() => {
		scroll();
		init(getValFromLS("crId") || "0");
	}, []);

	const init = async (id) => {
		const url = new URL(`${API_URL}/crInfoInit`);
		const params = {
			id,
		};
		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json) {
				setNames({ ...json });
				setAlert({});
				if (json.resp === 0 && getValFromLS("crId")) {
					setValToLS("crId", "");
				}
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleUpdate = (name, value) => {
		if (name === "same" && value) {
			for (let n = 0; n < formElement.current.length; n++) {
				if (formElement.current[n].name === "charity") {
					const val = names.organization || "";
					formElement.current[n].value = val;
					setNames((names) => ({ ...names, charity: val }));
				} else if (formElement.current[n].name === "mailAddress") {
					const val = names.address || "";
					formElement.current[n].value = val;
					setNames((names) => ({ ...names, mailAddress: val }));
				} else if (formElement.current[n].name === "mailCity") {
					const val = names.city || "";
					formElement.current[n].value = val;
					setNames((names) => ({ ...names, mailCity: val }));
				} else if (formElement.current[n].name === "mailSt") {
					const val = names.st || "";
					formElement.current[n].value = val;
					setNames((names) => ({ ...names, mailSt: val }));
				} else if (formElement.current[n].name === "mailZip") {
					const val = names.zip || "";
					formElement.current[n].value = val;
					setNames((names) => ({ ...names, mailZip: val }));
				}
			}
		}
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleCheckboxes = (name, checked, val) => {
		let newValue = "";
		if (checked) {
			newValue = val;
		}
		setNames((names) => ({ ...names, [name]: newValue }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/crInfo`);
		let formData = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			if (key === "same" || key === "new" || key === "golf") {
				formData.append(key, value ? "1" : "0");
			} else if (key === "cats" || key === "regions") {
				formData.append(key, JSON.stringify(value));
			} else {
				formData.append(key, value);
			}
		});

		try {
			const response = await fetch(url, {
				method: "POST",
				body: formData,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setValToLS("crId", json.id);
				history.push("/registration");
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<div id="full-column">
			<Hdg section="Registration" />
			<>
				{alert.type ? (
					<Alert data={alert} />
				) : (
					<>
						<h3>
							<i className="fa fa-building-o" /> &nbsp;Charity Information
						</h3>

						{names.id === "0" && (
							<>
								<p>
									Charities and school programs are welcome to register and
									participate for free in the 2026-2027 fundraising campaign.
									Register no later than{" "}
									<span style={{ color: "red" }}>Tuesday, September 8</span>, in
									order to receive custom, pre-printed donation forms for the
									upcoming fundraising season.
								</p>

								<p>
									The Valero Texas Open absorbs the covers costs to host events,
									provide program materials, and absorb merchant fees. In turn,
									participating nonprofits are asked to raise a minimum of
									$1,000 during the campaign season (between October 2026 -
									April 2027) to be invited back for the 2027-2028 campaign.
								</p>

								<p>
									Eligible charities and school programs must provide services
									and have a presence in one of the following states:
									California, Louisiana, Oklahoma, Tennessee, and/or Texas.
									Charities from other states can reach out to determine
									eligibility by contacting{" "}
									<a href="mailto:stephanie@valerotexasopen.com">
										Stephanie@ValeroTexasOpen.com
									</a>{" "}
									for more information.
								</p>

								<p>
									Please note that Individual and corporate donations must
									reside in one of the following states to participate:
									California, Louisiana, Oklahoma, Tennessee, and or Texas.
									Donors from all other states must contribute directly to the
									charity of choice.
								</p>

								<p>
									The fundraising program will kick-off October 14. Donations
									and commitments are welcome October 14 - April 12 for the
									campaign season. Funds raised between October - January will
									be distributed in February at a Mid-Season Social and again at
									the conclusion of the campaign in May at the Celebration of
									Champions luncheon.
								</p>
							</>
						)}

						<p>
							Please fill out this form completely with your Charity’s
							information, there will be 5 other sections to complete before
							submitting your registration.
						</p>

						<p>
							Should you have any questions, please contact{" "}
							<a href="mailto:stephanie@valerotexasopen.com">
								Stephanie@ValeroTexasOpen.com
							</a>{" "}
							or at 210.345.3839.
						</p>

						<form
							ref={formElement}
							method="post"
							action="/"
							onSubmit={(e) => handleSubmit(e)}
							className="well"
						>
							<div className="form-group">
								<Input
									name="organization"
									label="Organization Full Legal Name"
									reqd={true}
									value={names.organization || ""}
									update={handleUpdate}
									errors={errors}
								/>
								<Input
									name="address"
									label="Physical Address"
									reqd={true}
									value={names.address || ""}
									update={handleUpdate}
									errors={errors}
								/>
							</div>
							<div className="form-group three">
								<Input
									name="city"
									label="City"
									reqd={true}
									value={names.city || ""}
									update={handleUpdate}
									errors={errors}
								/>
								<Input
									name="st"
									label="State (2-letter)"
									reqd={true}
									value={names.st || ""}
									update={handleUpdate}
									errors={errors}
								/>
								<Input
									name="zip"
									label="Zip Code"
									reqd={true}
									value={names.zip || ""}
									update={handleUpdate}
									errors={errors}
								/>
							</div>

							<div className="form-group three">
								<Input
									name="phone"
									label="Phone"
									reqd={true}
									value={names.phone || ""}
									update={handleUpdate}
									errors={errors}
								/>
								<Input
									name="fax"
									label="Fax"
									reqd={false}
									value={names.fax || ""}
									update={handleUpdate}
									errors={errors}
								/>
								<Input
									name="website"
									label="Web Site"
									reqd={false}
									value={names.website || ""}
									update={handleUpdate}
									errors={errors}
								/>
							</div>

							<div className="form-group three">
								<Input
									name="facebook"
									label="Facebook Handle"
									reqd={false}
									value={names.facebook || ""}
									update={handleUpdate}
									errors={errors}
									placeholder="@"
								/>
								<Input
									name="instagram"
									label="Instagram Handle"
									reqd={false}
									value={names.instagram || ""}
									update={handleUpdate}
									errors={errors}
									placeholder="@"
								/>
								<Input
									name="twitter"
									label="Twitter Handle"
									reqd={false}
									value={names.twitter || ""}
									update={handleUpdate}
									errors={errors}
									placeholder="@"
								/>
							</div>

							<div className="form-group checkbox">
								<Checkbox
									name="same"
									label="Check if remittance name/address same as above"
									checked={false}
									click={handleUpdate}
								/>
							</div>

							<div className="form-group">
								<Input
									name="charity"
									label="Organization Name (DBA)"
									reqd={true}
									value={names.charity || ""}
									update={handleUpdate}
									errors={errors}
									note="This is how it will be listed on website, donation forms, etc."
								/>
								<Input
									name="mailAddress"
									label="Mailing Address"
									reqd={true}
									value={names.mailAddress || ""}
									update={handleUpdate}
									errors={errors}
								/>
							</div>
							<div className="form-group three">
								<Input
									name="mailCity"
									label="City"
									reqd={true}
									value={names.mailCity || ""}
									update={handleUpdate}
									errors={errors}
								/>
								<Input
									name="mailSt"
									label="State (2-letter)"
									reqd={true}
									value={names.mailSt || ""}
									update={handleUpdate}
									errors={errors}
								/>
								<Input
									name="mailZip"
									label="Zip Code"
									reqd={true}
									value={names.mailZip || ""}
									update={handleUpdate}
									errors={errors}
								/>
							</div>

							<div className="form-group">
								<Input
									name="director"
									label="Executive Director/Principal Name"
									reqd={false}
									value={names.director || ""}
									update={handleUpdate}
									errors={errors}
								/>
								<Input
									name="ein"
									label="EIN #"
									reqd={true}
									value={names.ein || ""}
									update={handleUpdate}
									errors={errors}
									placeholder="xx-xxxxxxx"
								/>
							</div>

							<div>
								<p>
									Based on your dba and how the funds will be used (locally,
									regionally, etc.), what is your organization’s operating
									budget? Examples:
								</p>

								<ul>
									<li style={{ fontStyle: "italic" }}>
										If the organization is registered for a high school golf
										program, please provide the operating budget for the golf
										program, not the school and/or athletic program as a whole.
									</li>

									<li style={{ fontStyle: "italic" }}>
										If the organization is registered as a local chapter, please
										provide the operating budget for the local chapter, not the
										operating budget for the national organization.
									</li>
								</ul>
							</div>

							<div className="form-group">
								<Input
									name="budget"
									label="Annual Operating Budget ($)"
									reqd={true}
									value={names.budget || ""}
									update={handleUpdate}
									errors={errors}
								/>

								<div className="empty" />
							</div>

							{/* removed this year per Stephanie <p>
								Based on the annual operating budget, your organization’s
								operating budget falls within which tier?
							</p>

							<div className="form-group">
								<Select
									name="tier"
									label="Annual Operating Budget Tier"
									reqd={true}
									value={names.tier || ""}
									options={[
										{ id: "", name: "--" },
										{ id: "A", name: "$1K - $19K" },
										{ id: "B", name: "$20K - $49K" },
										{ id: "C", name: "$50K - $99K" },
										{ id: "D", name: "$100K - $249K" },
										{ id: "E", name: "$250K - $499K" },
										{ id: "F", name: "$500K - $999K" },
										{ id: "G", name: "$1M - $3M" },
										{ id: "H", name: "$4M - $9M" },
										{ id: "I", name: "$10M - $19M" },
										{ id: "J", name: "$20M - $49M" },
										{ id: "K", name: "$50M - $100M" },
										{ id: "L", name: "$101M+" },
									]}
									update={handleUpdate}
									error={errors, "tier")}
								/>

								<div className="empty" />
							</div>*/}

							<div className="form-group radios">
								<Checkboxes
									label="Check which categories best fit your organization’s primary mission:"
									sublabel="When donors visit <a href='https://valerotexasopen.com/championsforecharity/participating-charities' target='_blank' rel='noopener noreferrer'>Participating Charities</a> they can filter the list based on Charitable Mission. Your charity name will appear under the categories you select from the options down below."
									reqd={true}
									data={names.cats}
									values={Object.entries(names)
										.filter(([key]) => /^cat\d+$/.test(key))
										.map(([, value]) => value)}
									click={handleCheckboxes}
								/>
							</div>

							<div className="form-group radios">
								<Checkboxes
									label="Check which regions best fit your organization:"
									sublabel="When donors visit <a href='https://valerotexasopen.com/championsforecharity/participating-charities' target='_blank' rel='noopener noreferrer'>Participating Charities</a> they can filter the list based on Regions. Your charity name will appear under the categories you select from the options down below."
									reqd={true}
									data={names.regions}
									values={Object.entries(names)
										.filter(([key]) => /^region\d+$/.test(key))
										.map(([, value]) => value)}
									click={handleCheckboxes}
								/>
							</div>

							{/*replaced for 2026-2027 <div className="form-group" style={{ marginTop: "15px" }}>
								<Input
									name="citiesServedTx"
									label="Cities Served in Texas"
									reqd={true}
									value={names.citiesServedTx || ""}
									update={handleUpdate}
									errors={errors}
								/>
								<div className="empty" />
							</div>
							<div className="form-group" style={{ marginTop: "15px" }}>
								<Input
									name="citiesServedOther"
									label="Cities Served outside of Texas"
									reqd={false}
									value={names.citiesServedOther || ""}
									update={handleUpdate}
									errors={errors}
									note="If your organization serves cities outside of Texas, please indicate city & state."
								/>
								<div className="empty" />
							</div>*/}

							<div
								className="form-group checkbox"
								style={{ marginTop: "10px" }}
							>
								<Checkbox
									name="new"
									label="Check if organization is new to program"
									checked={names.new || false}
									click={handleUpdate}
								/>
							</div>

							<div className={!names.new ? "hidden" : ""}>
								<div className="form-group">
									<Input
										name="newReferred"
										label="Referred by charity/school"
										reqd={false}
										value={names.newReferred || ""}
										update={handleUpdate}
										errors={errors}
									/>
									<Input
										name="newContact"
										label="Contact Name"
										reqd={false}
										value={names.newContact || ""}
										update={handleUpdate}
										errors={errors}
									/>
								</div>
							</div>

							<div
								className="form-group checkbox"
								style={{ marginTop: "10px" }}
							>
								<Checkbox
									name="golf"
									label="Yes, we host an annual golf tournament"
									checked={names.golf || false}
									click={handleUpdate}
								/>
							</div>

							<div className={!names.golf ? "hidden" : ""}>
								<div className="form-group">
									<Input
										name="golfNext"
										label="Next Scheduled Tournament Date"
										reqd={false}
										value={names.golfNext || ""}
										update={handleUpdate}
										errors={errors}
									/>
									<div className="empty" />
								</div>
							</div>

							<div className="msg-submit">
								{msg.type && <Msg data={msg} />}

								<div
									className={
										msg.type === "working" || msg.type === "success"
											? "hidden"
											: "submit-container"
									}
								>
									<Submit
										path="/registration"
										left="Back"
										submit="Submit Charity Information"
									/>
								</div>
							</div>
						</form>
					</>
				)}
			</>
		</div>
	);
};

export default CharityRegHome;
